import React from "react"
import { ReviewContainer, Star, StarsContainer } from "./styles"

const ProductRatings = ({ review }) => {
  if (!review) {
    return null
  }

  const averageRating = review?.productScore
  const { totalReviews } = review

  return (
    <div>
      {averageRating ? (
        <ReviewContainer>
          <StarsContainer>
            {[1, 2, 3, 4, 5].map((starNum) => (
              <Star key={starNum} active={starNum <= Math.round(averageRating)}>
                {starNum <= Math.round(averageRating) ? "★" : "☆"}
              </Star>
            ))}
          </StarsContainer>
          <span>({totalReviews})</span>
        </ReviewContainer>
      ) : (
        <ReviewContainer>
          <StarsContainer>
            {[1, 2, 3, 4, 5].map((starNum) => (
              <Star key={starNum} active={false}>
                ☆
              </Star>
            ))}
          </StarsContainer>
          <span>({totalReviews})</span>
        </ReviewContainer>
      )}
    </div>
  )
}

export default ProductRatings
